import api from "./api";

const customerService = {
  async getAll(params = {}) {
    try {
      const response = await api.get("/customers", { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getById(id) {
    try {
      const response = await api.get(`/customers/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async create(customerData) {
    try {
      const response = await api.post("/customers", customerData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async update(id, customerData) {
    try {
      const response = await api.put(`/customers/${id}`, customerData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async delete(id) {
    try {
      const response = await api.delete(`/customers/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async toggleStatus(id) {
    try {
      const response = await api.patch(`/customers/${id}/toggle-status`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default customerService;
